import { Fancybox } from '@fancyapps/ui';

/**
 * Photo Gallery filter — handles the .gallery-filters tab bar on
 * the Photo Gallery page. Clicking a filter tab shows/hides grid items
 * matching data-category. "All" always shows everything.
 */

export function initGalleryFilter() {
  const filtersNav = document.querySelector( '.gallery-filters' );
  const grid       = document.getElementById( 'gallery-grid' );

  if ( filtersNav && grid ) {
    const filters = filtersNav.querySelectorAll( '.gallery-filter' );
    const items   = grid.querySelectorAll( '.gallery-item' );

    filtersNav.addEventListener( 'click', e => {
      const btn = e.target.closest( '.gallery-filter' );
      if ( ! btn ) return;

      const category = btn.dataset.filter;

      filters.forEach( f => {
        f.classList.toggle( 'is-active', f === btn );
        f.setAttribute( 'aria-pressed', f === btn ? 'true' : 'false' );
      } );

      items.forEach( item => {
        const match = category === 'all' || item.dataset.category === category;
        item.hidden = ! match;
      } );
    } );
  }

  if ( document.querySelector( '[data-fancybox="gallery"]' ) ) {
    Fancybox.bind( '[data-fancybox="gallery"]' );
  }
}
